import React, { useCallback } from 'react'
import { Row, Col } from 'react-grid-system'
import { Input } from '../../common/form/fields'

export const CommentOnlyView = ({
   handleCommentChange,
}: {
   handleCommentChange: (value: string, comment: any) => void
}) => {
   const handleCommentFieldChange = useCallback(
      (comment) => handleCommentChange('Comment', comment),
      [handleCommentChange]
   )

   return (
      <Row gutterWidth={20}>
         <Col md={12}>
            <Input
               id="Comment"
               maxLength={100}
               label="Comment (optional)"
               onChange={handleCommentFieldChange}
            />
         </Col>
      </Row>
   )
}
